/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as HelpRouteImport } from './routes/help'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as SelfServiceCreateUserRouteImport } from './routes/selfServiceCreateUser'
import { Route as AuthAwardsRouteImport } from './routes/_auth/awards'
import { Route as AuthBeginRouteImport } from './routes/_auth/begin'
import { Route as AuthBirthdaysRouteImport } from './routes/_auth/birthdays'
import { Route as AuthBulkUpdateSectionRouteImport } from './routes/_auth/bulkUpdateSection'
import { Route as AuthCalendarRouteImport } from './routes/_auth/calendar'
import { Route as AuthChartsRouteImport } from './routes/_auth/charts'
import { Route as AuthCreateMemberRouteImport } from './routes/_auth/createMember'
import { Route as AuthEducationRouteImport } from './routes/_auth/education'
import { Route as AuthEducationImportRouteImport } from './routes/_auth/educationImport'
import { Route as AuthGildeReportsRouteImport } from './routes/_auth/gildeReports'
import { Route as AuthGrinsExportsRouteImport } from './routes/_auth/grinsExports'
import { Route as AuthGrinsViewRouteImport } from './routes/_auth/grinsView'
import { Route as AuthListMemberPivotRouteImport } from './routes/_auth/listMemberPivot'
import { Route as AuthListsRouteImport } from './routes/_auth/lists'
import { Route as AuthMedusaImportRouteImport } from './routes/_auth/medusaImport'
import { Route as AuthMembershipsRouteImport } from './routes/_auth/memberships'
import { Route as AuthMembershipsOverviewRouteImport } from './routes/_auth/membershipsOverview'
import { Route as AuthOrganizationHierarchyRouteImport } from './routes/_auth/organizationHierarchy'
import { Route as AuthPermissionConfigRouteImport } from './routes/_auth/permissionConfig'
import { Route as AuthPostreceiverRouteImport } from './routes/_auth/postreceiver'
import { Route as AuthQualityAddressRouteImport } from './routes/_auth/qualityAddress'
import { Route as AuthQualityMemberRouteImport } from './routes/_auth/qualityMember'
import { Route as AuthRegistrationRouteImport } from './routes/_auth/registration'
import { Route as AuthReportsRouteImport } from './routes/_auth/reports'
import { Route as AuthScoutcardRequestsRouteImport } from './routes/_auth/scoutcardRequests'
import { Route as AuthScoutcardsRouteImport } from './routes/_auth/scoutcards'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings'
import { Route as AuthStartRouteImport } from './routes/_auth/start'
import { Route as AuthSwitchOrganizationRouteImport } from './routes/_auth/switchOrganization'
import { Route as AuthUploadMemberRouteImport } from './routes/_auth/uploadMember'
import { Route as ApproveMembershipRequestMembershipRequestCodeRouteImport } from './routes/approveMembershipRequest_.$membershipRequestCode'
import { Route as DownloadReportReportUuidRouteImport } from './routes/downloadReport_.$reportUuid'
import { Route as AuthCreateMembershipRequestMembershipUuidRouteImport } from './routes/_auth/createMembershipRequest_.$membershipUuid'
import { Route as AuthListListHeaderUuidRouteImport } from './routes/_auth/list_.$listHeaderUuid'
import { Route as AuthMemberMemberUuidRouteImport } from './routes/_auth/member_.$memberUuid'
import { Route as AuthMembershipMembershipUuidRouteImport } from './routes/_auth/membership_.$membershipUuid'
import { Route as AuthMembershiprequestUuidRouteImport } from './routes/_auth/membershiprequest_.$uuid'
import { Route as AuthOrganizationOrganizationUuidRouteImport } from './routes/_auth/organization_.$organizationUuid'
import { Route as AuthMemberMemberUuidAwardsRouteImport } from './routes/_auth/member_.$memberUuid.awards'
import { Route as AuthMemberMemberUuidContactsRouteImport } from './routes/_auth/member_.$memberUuid.contacts'
import { Route as AuthMemberMemberUuidDescriptionsRouteImport } from './routes/_auth/member_.$memberUuid.descriptions'
import { Route as AuthMemberMemberUuidDynamicFieldsRouteImport } from './routes/_auth/member_.$memberUuid.dynamicFields'
import { Route as AuthMemberMemberUuidDynamicFieldsGridRouteImport } from './routes/_auth/member_.$memberUuid.dynamicFieldsGrid'
import { Route as AuthMemberMemberUuidEducationRouteImport } from './routes/_auth/member_.$memberUuid.education'
import { Route as AuthMemberMemberUuidImagesRouteImport } from './routes/_auth/member_.$memberUuid.images'
import { Route as AuthMemberMemberUuidInfoRouteImport } from './routes/_auth/member_.$memberUuid.info'
import { Route as AuthMemberMemberUuidJobsRouteImport } from './routes/_auth/member_.$memberUuid.jobs'
import { Route as AuthMemberMemberUuidListsRouteImport } from './routes/_auth/member_.$memberUuid.lists'
import { Route as AuthMemberMemberUuidMainRouteImport } from './routes/_auth/member_.$memberUuid.main'
import { Route as AuthMemberMemberUuidMembershipSettingsRouteImport } from './routes/_auth/member_.$memberUuid.membershipSettings'
import { Route as AuthMemberMemberUuidMembershipsRouteImport } from './routes/_auth/member_.$memberUuid.memberships'
import { Route as AuthMemberMemberUuidPermissionsRouteImport } from './routes/_auth/member_.$memberUuid.permissions'
import { Route as AuthMemberMemberUuidRegistrationRecordsRouteImport } from './routes/_auth/member_.$memberUuid.registrationRecords'
import { Route as AuthMemberMemberUuidRelationsRouteImport } from './routes/_auth/member_.$memberUuid.relations'
import { Route as AuthMemberMemberUuidRevisionsRouteImport } from './routes/_auth/member_.$memberUuid.revisions'
import { Route as AuthMemberMemberUuidSectionsRouteImport } from './routes/_auth/member_.$memberUuid.sections'
import { Route as AuthMemberMemberUuidUserRouteImport } from './routes/_auth/member_.$memberUuid.user'
import { Route as AuthMembershipMembershipUuidMainRouteImport } from './routes/_auth/membership_.$membershipUuid.main'
import { Route as AuthOrganizationOrganizationUuidAwardsRouteImport } from './routes/_auth/organization_.$organizationUuid.awards'
import { Route as AuthOrganizationOrganizationUuidDsgvoRequestRouteImport } from './routes/_auth/organization_.$organizationUuid.dsgvoRequest'
import { Route as AuthOrganizationOrganizationUuidDynamicFieldsRouteImport } from './routes/_auth/organization_.$organizationUuid.dynamicFields'
import { Route as AuthOrganizationOrganizationUuidDynamicFieldsTableRouteImport } from './routes/_auth/organization_.$organizationUuid.dynamicFieldsTable'
import { Route as AuthOrganizationOrganizationUuidEducationRouteImport } from './routes/_auth/organization_.$organizationUuid.education'
import { Route as AuthOrganizationOrganizationUuidImagesRouteImport } from './routes/_auth/organization_.$organizationUuid.images'
import { Route as AuthOrganizationOrganizationUuidInfoRouteImport } from './routes/_auth/organization_.$organizationUuid.info'
import { Route as AuthOrganizationOrganizationUuidJobsRouteImport } from './routes/_auth/organization_.$organizationUuid.jobs'
import { Route as AuthOrganizationOrganizationUuidMainRouteImport } from './routes/_auth/organization_.$organizationUuid.main'
import { Route as AuthOrganizationOrganizationUuidMembershipRequestsRouteImport } from './routes/_auth/organization_.$organizationUuid.membershipRequests'
import { Route as AuthOrganizationOrganizationUuidMigrationsRouteImport } from './routes/_auth/organization_.$organizationUuid.migrations'
import { Route as AuthOrganizationOrganizationUuidPaymentRouteImport } from './routes/_auth/organization_.$organizationUuid.payment'
import { Route as AuthOrganizationOrganizationUuidPermissionsRouteImport } from './routes/_auth/organization_.$organizationUuid.permissions'
import { Route as AuthOrganizationOrganizationUuidRevisionsRouteImport } from './routes/_auth/organization_.$organizationUuid.revisions'
import { Route as AuthOrganizationOrganizationUuidSectionTimesRouteImport } from './routes/_auth/organization_.$organizationUuid.sectionTimes'
import { Route as AuthOrganizationOrganizationUuidSectionsRouteImport } from './routes/_auth/organization_.$organizationUuid.sections'
import { Route as AuthMemberMemberUuidMemberawardUuidRouteImport } from './routes/_auth/member_.$memberUuid.memberaward_.$uuid'
import { Route as AuthMemberMemberUuidMemberjobUuidRouteImport } from './routes/_auth/member_.$memberUuid.memberjob_.$uuid'
import { Route as AuthMemberMemberUuidMembersectionUuidRouteImport } from './routes/_auth/member_.$memberUuid.membersection_.$uuid'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const SelfServiceCreateUserRoute = SelfServiceCreateUserRouteImport.update({
  id: '/selfServiceCreateUser',
  path: '/selfServiceCreateUser',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAwardsRoute = AuthAwardsRouteImport.update({
  id: '/awards',
  path: '/awards',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBeginRoute = AuthBeginRouteImport.update({
  id: '/begin',
  path: '/begin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBirthdaysRoute = AuthBirthdaysRouteImport.update({
  id: '/birthdays',
  path: '/birthdays',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBulkUpdateSectionRoute = AuthBulkUpdateSectionRouteImport.update({
  id: '/bulkUpdateSection',
  path: '/bulkUpdateSection',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCalendarRoute = AuthCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChartsRoute = AuthChartsRouteImport.update({
  id: '/charts',
  path: '/charts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCreateMemberRoute = AuthCreateMemberRouteImport.update({
  id: '/createMember',
  path: '/createMember',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEducationRoute = AuthEducationRouteImport.update({
  id: '/education',
  path: '/education',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEducationImportRoute = AuthEducationImportRouteImport.update({
  id: '/educationImport',
  path: '/educationImport',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGildeReportsRoute = AuthGildeReportsRouteImport.update({
  id: '/gildeReports',
  path: '/gildeReports',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGrinsExportsRoute = AuthGrinsExportsRouteImport.update({
  id: '/grinsExports',
  path: '/grinsExports',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGrinsViewRoute = AuthGrinsViewRouteImport.update({
  id: '/grinsView',
  path: '/grinsView',
  getParentRoute: () => AuthRoute,
} as any)
const AuthListMemberPivotRoute = AuthListMemberPivotRouteImport.update({
  id: '/listMemberPivot',
  path: '/listMemberPivot',
  getParentRoute: () => AuthRoute,
} as any)
const AuthListsRoute = AuthListsRouteImport.update({
  id: '/lists',
  path: '/lists',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMedusaImportRoute = AuthMedusaImportRouteImport.update({
  id: '/medusaImport',
  path: '/medusaImport',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMembershipsRoute = AuthMembershipsRouteImport.update({
  id: '/memberships',
  path: '/memberships',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMembershipsOverviewRoute = AuthMembershipsOverviewRouteImport.update({
  id: '/membershipsOverview',
  path: '/membershipsOverview',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrganizationHierarchyRoute =
  AuthOrganizationHierarchyRouteImport.update({
    id: '/organizationHierarchy',
    path: '/organizationHierarchy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPermissionConfigRoute = AuthPermissionConfigRouteImport.update({
  id: '/permissionConfig',
  path: '/permissionConfig',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPostreceiverRoute = AuthPostreceiverRouteImport.update({
  id: '/postreceiver',
  path: '/postreceiver',
  getParentRoute: () => AuthRoute,
} as any)
const AuthQualityAddressRoute = AuthQualityAddressRouteImport.update({
  id: '/qualityAddress',
  path: '/qualityAddress',
  getParentRoute: () => AuthRoute,
} as any)
const AuthQualityMemberRoute = AuthQualityMemberRouteImport.update({
  id: '/qualityMember',
  path: '/qualityMember',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegistrationRoute = AuthRegistrationRouteImport.update({
  id: '/registration',
  path: '/registration',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsRoute = AuthReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScoutcardRequestsRoute = AuthScoutcardRequestsRouteImport.update({
  id: '/scoutcardRequests',
  path: '/scoutcardRequests',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScoutcardsRoute = AuthScoutcardsRouteImport.update({
  id: '/scoutcards',
  path: '/scoutcards',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStartRoute = AuthStartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSwitchOrganizationRoute = AuthSwitchOrganizationRouteImport.update({
  id: '/switchOrganization',
  path: '/switchOrganization',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUploadMemberRoute = AuthUploadMemberRouteImport.update({
  id: '/uploadMember',
  path: '/uploadMember',
  getParentRoute: () => AuthRoute,
} as any)
const ApproveMembershipRequestMembershipRequestCodeRoute =
  ApproveMembershipRequestMembershipRequestCodeRouteImport.update({
    id: '/approveMembershipRequest_/$membershipRequestCode',
    path: '/approveMembershipRequest/$membershipRequestCode',
    getParentRoute: () => rootRouteImport,
  } as any)
const DownloadReportReportUuidRoute =
  DownloadReportReportUuidRouteImport.update({
    id: '/downloadReport_/$reportUuid',
    path: '/downloadReport/$reportUuid',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthCreateMembershipRequestMembershipUuidRoute =
  AuthCreateMembershipRequestMembershipUuidRouteImport.update({
    id: '/createMembershipRequest_/$membershipUuid',
    path: '/createMembershipRequest/$membershipUuid',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthListListHeaderUuidRoute = AuthListListHeaderUuidRouteImport.update({
  id: '/list_/$listHeaderUuid',
  path: '/list/$listHeaderUuid',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMemberMemberUuidRoute = AuthMemberMemberUuidRouteImport.update({
  id: '/member_/$memberUuid',
  path: '/member/$memberUuid',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMembershipMembershipUuidRoute =
  AuthMembershipMembershipUuidRouteImport.update({
    id: '/membership_/$membershipUuid',
    path: '/membership/$membershipUuid',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMembershiprequestUuidRoute =
  AuthMembershiprequestUuidRouteImport.update({
    id: '/membershiprequest_/$uuid',
    path: '/membershiprequest/$uuid',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthOrganizationOrganizationUuidRoute =
  AuthOrganizationOrganizationUuidRouteImport.update({
    id: '/organization_/$organizationUuid',
    path: '/organization/$organizationUuid',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMemberMemberUuidAwardsRoute =
  AuthMemberMemberUuidAwardsRouteImport.update({
    id: '/awards',
    path: '/awards',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidContactsRoute =
  AuthMemberMemberUuidContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidDescriptionsRoute =
  AuthMemberMemberUuidDescriptionsRouteImport.update({
    id: '/descriptions',
    path: '/descriptions',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidDynamicFieldsRoute =
  AuthMemberMemberUuidDynamicFieldsRouteImport.update({
    id: '/dynamicFields',
    path: '/dynamicFields',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidDynamicFieldsGridRoute =
  AuthMemberMemberUuidDynamicFieldsGridRouteImport.update({
    id: '/dynamicFieldsGrid',
    path: '/dynamicFieldsGrid',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidEducationRoute =
  AuthMemberMemberUuidEducationRouteImport.update({
    id: '/education',
    path: '/education',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidImagesRoute =
  AuthMemberMemberUuidImagesRouteImport.update({
    id: '/images',
    path: '/images',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidInfoRoute =
  AuthMemberMemberUuidInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidJobsRoute =
  AuthMemberMemberUuidJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidListsRoute =
  AuthMemberMemberUuidListsRouteImport.update({
    id: '/lists',
    path: '/lists',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidMainRoute =
  AuthMemberMemberUuidMainRouteImport.update({
    id: '/main',
    path: '/main',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidMembershipSettingsRoute =
  AuthMemberMemberUuidMembershipSettingsRouteImport.update({
    id: '/membershipSettings',
    path: '/membershipSettings',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidMembershipsRoute =
  AuthMemberMemberUuidMembershipsRouteImport.update({
    id: '/memberships',
    path: '/memberships',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidPermissionsRoute =
  AuthMemberMemberUuidPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidRegistrationRecordsRoute =
  AuthMemberMemberUuidRegistrationRecordsRouteImport.update({
    id: '/registrationRecords',
    path: '/registrationRecords',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidRelationsRoute =
  AuthMemberMemberUuidRelationsRouteImport.update({
    id: '/relations',
    path: '/relations',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidRevisionsRoute =
  AuthMemberMemberUuidRevisionsRouteImport.update({
    id: '/revisions',
    path: '/revisions',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidSectionsRoute =
  AuthMemberMemberUuidSectionsRouteImport.update({
    id: '/sections',
    path: '/sections',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidUserRoute =
  AuthMemberMemberUuidUserRouteImport.update({
    id: '/user',
    path: '/user',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMembershipMembershipUuidMainRoute =
  AuthMembershipMembershipUuidMainRouteImport.update({
    id: '/main',
    path: '/main',
    getParentRoute: () => AuthMembershipMembershipUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidAwardsRoute =
  AuthOrganizationOrganizationUuidAwardsRouteImport.update({
    id: '/awards',
    path: '/awards',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidDsgvoRequestRoute =
  AuthOrganizationOrganizationUuidDsgvoRequestRouteImport.update({
    id: '/dsgvoRequest',
    path: '/dsgvoRequest',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidDynamicFieldsRoute =
  AuthOrganizationOrganizationUuidDynamicFieldsRouteImport.update({
    id: '/dynamicFields',
    path: '/dynamicFields',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidDynamicFieldsTableRoute =
  AuthOrganizationOrganizationUuidDynamicFieldsTableRouteImport.update({
    id: '/dynamicFieldsTable',
    path: '/dynamicFieldsTable',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidEducationRoute =
  AuthOrganizationOrganizationUuidEducationRouteImport.update({
    id: '/education',
    path: '/education',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidImagesRoute =
  AuthOrganizationOrganizationUuidImagesRouteImport.update({
    id: '/images',
    path: '/images',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidInfoRoute =
  AuthOrganizationOrganizationUuidInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidJobsRoute =
  AuthOrganizationOrganizationUuidJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidMainRoute =
  AuthOrganizationOrganizationUuidMainRouteImport.update({
    id: '/main',
    path: '/main',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidMembershipRequestsRoute =
  AuthOrganizationOrganizationUuidMembershipRequestsRouteImport.update({
    id: '/membershipRequests',
    path: '/membershipRequests',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidMigrationsRoute =
  AuthOrganizationOrganizationUuidMigrationsRouteImport.update({
    id: '/migrations',
    path: '/migrations',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidPaymentRoute =
  AuthOrganizationOrganizationUuidPaymentRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidPermissionsRoute =
  AuthOrganizationOrganizationUuidPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidRevisionsRoute =
  AuthOrganizationOrganizationUuidRevisionsRouteImport.update({
    id: '/revisions',
    path: '/revisions',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidSectionTimesRoute =
  AuthOrganizationOrganizationUuidSectionTimesRouteImport.update({
    id: '/sectionTimes',
    path: '/sectionTimes',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthOrganizationOrganizationUuidSectionsRoute =
  AuthOrganizationOrganizationUuidSectionsRouteImport.update({
    id: '/sections',
    path: '/sections',
    getParentRoute: () => AuthOrganizationOrganizationUuidRoute,
  } as any)
const AuthMemberMemberUuidMemberawardUuidRoute =
  AuthMemberMemberUuidMemberawardUuidRouteImport.update({
    id: '/memberaward_/$uuid',
    path: '/memberaward/$uuid',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidMemberjobUuidRoute =
  AuthMemberMemberUuidMemberjobUuidRouteImport.update({
    id: '/memberjob_/$uuid',
    path: '/memberjob/$uuid',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)
const AuthMemberMemberUuidMembersectionUuidRoute =
  AuthMemberMemberUuidMembersectionUuidRouteImport.update({
    id: '/membersection_/$uuid',
    path: '/membersection/$uuid',
    getParentRoute: () => AuthMemberMemberUuidRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/help': typeof HelpRoute
  '/logout': typeof LogoutRoute
  '/selfServiceCreateUser': typeof SelfServiceCreateUserRoute
  '/awards': typeof AuthAwardsRoute
  '/begin': typeof AuthBeginRoute
  '/birthdays': typeof AuthBirthdaysRoute
  '/bulkUpdateSection': typeof AuthBulkUpdateSectionRoute
  '/calendar': typeof AuthCalendarRoute
  '/charts': typeof AuthChartsRoute
  '/createMember': typeof AuthCreateMemberRoute
  '/education': typeof AuthEducationRoute
  '/educationImport': typeof AuthEducationImportRoute
  '/gildeReports': typeof AuthGildeReportsRoute
  '/grinsExports': typeof AuthGrinsExportsRoute
  '/grinsView': typeof AuthGrinsViewRoute
  '/listMemberPivot': typeof AuthListMemberPivotRoute
  '/lists': typeof AuthListsRoute
  '/medusaImport': typeof AuthMedusaImportRoute
  '/memberships': typeof AuthMembershipsRoute
  '/membershipsOverview': typeof AuthMembershipsOverviewRoute
  '/organizationHierarchy': typeof AuthOrganizationHierarchyRoute
  '/permissionConfig': typeof AuthPermissionConfigRoute
  '/postreceiver': typeof AuthPostreceiverRoute
  '/qualityAddress': typeof AuthQualityAddressRoute
  '/qualityMember': typeof AuthQualityMemberRoute
  '/registration': typeof AuthRegistrationRoute
  '/reports': typeof AuthReportsRoute
  '/scoutcardRequests': typeof AuthScoutcardRequestsRoute
  '/scoutcards': typeof AuthScoutcardsRoute
  '/settings': typeof AuthSettingsRoute
  '/start': typeof AuthStartRoute
  '/switchOrganization': typeof AuthSwitchOrganizationRoute
  '/uploadMember': typeof AuthUploadMemberRoute
  '/approveMembershipRequest/$membershipRequestCode': typeof ApproveMembershipRequestMembershipRequestCodeRoute
  '/downloadReport/$reportUuid': typeof DownloadReportReportUuidRoute
  '/createMembershipRequest/$membershipUuid': typeof AuthCreateMembershipRequestMembershipUuidRoute
  '/list/$listHeaderUuid': typeof AuthListListHeaderUuidRoute
  '/member/$memberUuid': typeof AuthMemberMemberUuidRouteWithChildren
  '/membership/$membershipUuid': typeof AuthMembershipMembershipUuidRouteWithChildren
  '/membershiprequest/$uuid': typeof AuthMembershiprequestUuidRoute
  '/organization/$organizationUuid': typeof AuthOrganizationOrganizationUuidRouteWithChildren
  '/member/$memberUuid/awards': typeof AuthMemberMemberUuidAwardsRoute
  '/member/$memberUuid/contacts': typeof AuthMemberMemberUuidContactsRoute
  '/member/$memberUuid/descriptions': typeof AuthMemberMemberUuidDescriptionsRoute
  '/member/$memberUuid/dynamicFields': typeof AuthMemberMemberUuidDynamicFieldsRoute
  '/member/$memberUuid/dynamicFieldsGrid': typeof AuthMemberMemberUuidDynamicFieldsGridRoute
  '/member/$memberUuid/education': typeof AuthMemberMemberUuidEducationRoute
  '/member/$memberUuid/images': typeof AuthMemberMemberUuidImagesRoute
  '/member/$memberUuid/info': typeof AuthMemberMemberUuidInfoRoute
  '/member/$memberUuid/jobs': typeof AuthMemberMemberUuidJobsRoute
  '/member/$memberUuid/lists': typeof AuthMemberMemberUuidListsRoute
  '/member/$memberUuid/main': typeof AuthMemberMemberUuidMainRoute
  '/member/$memberUuid/membershipSettings': typeof AuthMemberMemberUuidMembershipSettingsRoute
  '/member/$memberUuid/memberships': typeof AuthMemberMemberUuidMembershipsRoute
  '/member/$memberUuid/permissions': typeof AuthMemberMemberUuidPermissionsRoute
  '/member/$memberUuid/registrationRecords': typeof AuthMemberMemberUuidRegistrationRecordsRoute
  '/member/$memberUuid/relations': typeof AuthMemberMemberUuidRelationsRoute
  '/member/$memberUuid/revisions': typeof AuthMemberMemberUuidRevisionsRoute
  '/member/$memberUuid/sections': typeof AuthMemberMemberUuidSectionsRoute
  '/member/$memberUuid/user': typeof AuthMemberMemberUuidUserRoute
  '/membership/$membershipUuid/main': typeof AuthMembershipMembershipUuidMainRoute
  '/organization/$organizationUuid/awards': typeof AuthOrganizationOrganizationUuidAwardsRoute
  '/organization/$organizationUuid/dsgvoRequest': typeof AuthOrganizationOrganizationUuidDsgvoRequestRoute
  '/organization/$organizationUuid/dynamicFields': typeof AuthOrganizationOrganizationUuidDynamicFieldsRoute
  '/organization/$organizationUuid/dynamicFieldsTable': typeof AuthOrganizationOrganizationUuidDynamicFieldsTableRoute
  '/organization/$organizationUuid/education': typeof AuthOrganizationOrganizationUuidEducationRoute
  '/organization/$organizationUuid/images': typeof AuthOrganizationOrganizationUuidImagesRoute
  '/organization/$organizationUuid/info': typeof AuthOrganizationOrganizationUuidInfoRoute
  '/organization/$organizationUuid/jobs': typeof AuthOrganizationOrganizationUuidJobsRoute
  '/organization/$organizationUuid/main': typeof AuthOrganizationOrganizationUuidMainRoute
  '/organization/$organizationUuid/membershipRequests': typeof AuthOrganizationOrganizationUuidMembershipRequestsRoute
  '/organization/$organizationUuid/migrations': typeof AuthOrganizationOrganizationUuidMigrationsRoute
  '/organization/$organizationUuid/payment': typeof AuthOrganizationOrganizationUuidPaymentRoute
  '/organization/$organizationUuid/permissions': typeof AuthOrganizationOrganizationUuidPermissionsRoute
  '/organization/$organizationUuid/revisions': typeof AuthOrganizationOrganizationUuidRevisionsRoute
  '/organization/$organizationUuid/sectionTimes': typeof AuthOrganizationOrganizationUuidSectionTimesRoute
  '/organization/$organizationUuid/sections': typeof AuthOrganizationOrganizationUuidSectionsRoute
  '/member/$memberUuid/memberaward/$uuid': typeof AuthMemberMemberUuidMemberawardUuidRoute
  '/member/$memberUuid/memberjob/$uuid': typeof AuthMemberMemberUuidMemberjobUuidRoute
  '/member/$memberUuid/membersection/$uuid': typeof AuthMemberMemberUuidMembersectionUuidRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/help': typeof HelpRoute
  '/logout': typeof LogoutRoute
  '/selfServiceCreateUser': typeof SelfServiceCreateUserRoute
  '/awards': typeof AuthAwardsRoute
  '/begin': typeof AuthBeginRoute
  '/birthdays': typeof AuthBirthdaysRoute
  '/bulkUpdateSection': typeof AuthBulkUpdateSectionRoute
  '/calendar': typeof AuthCalendarRoute
  '/charts': typeof AuthChartsRoute
  '/createMember': typeof AuthCreateMemberRoute
  '/education': typeof AuthEducationRoute
  '/educationImport': typeof AuthEducationImportRoute
  '/gildeReports': typeof AuthGildeReportsRoute
  '/grinsExports': typeof AuthGrinsExportsRoute
  '/grinsView': typeof AuthGrinsViewRoute
  '/listMemberPivot': typeof AuthListMemberPivotRoute
  '/lists': typeof AuthListsRoute
  '/medusaImport': typeof AuthMedusaImportRoute
  '/memberships': typeof AuthMembershipsRoute
  '/membershipsOverview': typeof AuthMembershipsOverviewRoute
  '/organizationHierarchy': typeof AuthOrganizationHierarchyRoute
  '/permissionConfig': typeof AuthPermissionConfigRoute
  '/postreceiver': typeof AuthPostreceiverRoute
  '/qualityAddress': typeof AuthQualityAddressRoute
  '/qualityMember': typeof AuthQualityMemberRoute
  '/registration': typeof AuthRegistrationRoute
  '/reports': typeof AuthReportsRoute
  '/scoutcardRequests': typeof AuthScoutcardRequestsRoute
  '/scoutcards': typeof AuthScoutcardsRoute
  '/settings': typeof AuthSettingsRoute
  '/start': typeof AuthStartRoute
  '/switchOrganization': typeof AuthSwitchOrganizationRoute
  '/uploadMember': typeof AuthUploadMemberRoute
  '/approveMembershipRequest/$membershipRequestCode': typeof ApproveMembershipRequestMembershipRequestCodeRoute
  '/downloadReport/$reportUuid': typeof DownloadReportReportUuidRoute
  '/createMembershipRequest/$membershipUuid': typeof AuthCreateMembershipRequestMembershipUuidRoute
  '/list/$listHeaderUuid': typeof AuthListListHeaderUuidRoute
  '/member/$memberUuid': typeof AuthMemberMemberUuidRouteWithChildren
  '/membership/$membershipUuid': typeof AuthMembershipMembershipUuidRouteWithChildren
  '/membershiprequest/$uuid': typeof AuthMembershiprequestUuidRoute
  '/organization/$organizationUuid': typeof AuthOrganizationOrganizationUuidRouteWithChildren
  '/member/$memberUuid/awards': typeof AuthMemberMemberUuidAwardsRoute
  '/member/$memberUuid/contacts': typeof AuthMemberMemberUuidContactsRoute
  '/member/$memberUuid/descriptions': typeof AuthMemberMemberUuidDescriptionsRoute
  '/member/$memberUuid/dynamicFields': typeof AuthMemberMemberUuidDynamicFieldsRoute
  '/member/$memberUuid/dynamicFieldsGrid': typeof AuthMemberMemberUuidDynamicFieldsGridRoute
  '/member/$memberUuid/education': typeof AuthMemberMemberUuidEducationRoute
  '/member/$memberUuid/images': typeof AuthMemberMemberUuidImagesRoute
  '/member/$memberUuid/info': typeof AuthMemberMemberUuidInfoRoute
  '/member/$memberUuid/jobs': typeof AuthMemberMemberUuidJobsRoute
  '/member/$memberUuid/lists': typeof AuthMemberMemberUuidListsRoute
  '/member/$memberUuid/main': typeof AuthMemberMemberUuidMainRoute
  '/member/$memberUuid/membershipSettings': typeof AuthMemberMemberUuidMembershipSettingsRoute
  '/member/$memberUuid/memberships': typeof AuthMemberMemberUuidMembershipsRoute
  '/member/$memberUuid/permissions': typeof AuthMemberMemberUuidPermissionsRoute
  '/member/$memberUuid/registrationRecords': typeof AuthMemberMemberUuidRegistrationRecordsRoute
  '/member/$memberUuid/relations': typeof AuthMemberMemberUuidRelationsRoute
  '/member/$memberUuid/revisions': typeof AuthMemberMemberUuidRevisionsRoute
  '/member/$memberUuid/sections': typeof AuthMemberMemberUuidSectionsRoute
  '/member/$memberUuid/user': typeof AuthMemberMemberUuidUserRoute
  '/membership/$membershipUuid/main': typeof AuthMembershipMembershipUuidMainRoute
  '/organization/$organizationUuid/awards': typeof AuthOrganizationOrganizationUuidAwardsRoute
  '/organization/$organizationUuid/dsgvoRequest': typeof AuthOrganizationOrganizationUuidDsgvoRequestRoute
  '/organization/$organizationUuid/dynamicFields': typeof AuthOrganizationOrganizationUuidDynamicFieldsRoute
  '/organization/$organizationUuid/dynamicFieldsTable': typeof AuthOrganizationOrganizationUuidDynamicFieldsTableRoute
  '/organization/$organizationUuid/education': typeof AuthOrganizationOrganizationUuidEducationRoute
  '/organization/$organizationUuid/images': typeof AuthOrganizationOrganizationUuidImagesRoute
  '/organization/$organizationUuid/info': typeof AuthOrganizationOrganizationUuidInfoRoute
  '/organization/$organizationUuid/jobs': typeof AuthOrganizationOrganizationUuidJobsRoute
  '/organization/$organizationUuid/main': typeof AuthOrganizationOrganizationUuidMainRoute
  '/organization/$organizationUuid/membershipRequests': typeof AuthOrganizationOrganizationUuidMembershipRequestsRoute
  '/organization/$organizationUuid/migrations': typeof AuthOrganizationOrganizationUuidMigrationsRoute
  '/organization/$organizationUuid/payment': typeof AuthOrganizationOrganizationUuidPaymentRoute
  '/organization/$organizationUuid/permissions': typeof AuthOrganizationOrganizationUuidPermissionsRoute
  '/organization/$organizationUuid/revisions': typeof AuthOrganizationOrganizationUuidRevisionsRoute
  '/organization/$organizationUuid/sectionTimes': typeof AuthOrganizationOrganizationUuidSectionTimesRoute
  '/organization/$organizationUuid/sections': typeof AuthOrganizationOrganizationUuidSectionsRoute
  '/member/$memberUuid/memberaward/$uuid': typeof AuthMemberMemberUuidMemberawardUuidRoute
  '/member/$memberUuid/memberjob/$uuid': typeof AuthMemberMemberUuidMemberjobUuidRoute
  '/member/$memberUuid/membersection/$uuid': typeof AuthMemberMemberUuidMembersectionUuidRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/help': typeof HelpRoute
  '/logout': typeof LogoutRoute
  '/selfServiceCreateUser': typeof SelfServiceCreateUserRoute
  '/_auth/awards': typeof AuthAwardsRoute
  '/_auth/begin': typeof AuthBeginRoute
  '/_auth/birthdays': typeof AuthBirthdaysRoute
  '/_auth/bulkUpdateSection': typeof AuthBulkUpdateSectionRoute
  '/_auth/calendar': typeof AuthCalendarRoute
  '/_auth/charts': typeof AuthChartsRoute
  '/_auth/createMember': typeof AuthCreateMemberRoute
  '/_auth/education': typeof AuthEducationRoute
  '/_auth/educationImport': typeof AuthEducationImportRoute
  '/_auth/gildeReports': typeof AuthGildeReportsRoute
  '/_auth/grinsExports': typeof AuthGrinsExportsRoute
  '/_auth/grinsView': typeof AuthGrinsViewRoute
  '/_auth/listMemberPivot': typeof AuthListMemberPivotRoute
  '/_auth/lists': typeof AuthListsRoute
  '/_auth/medusaImport': typeof AuthMedusaImportRoute
  '/_auth/memberships': typeof AuthMembershipsRoute
  '/_auth/membershipsOverview': typeof AuthMembershipsOverviewRoute
  '/_auth/organizationHierarchy': typeof AuthOrganizationHierarchyRoute
  '/_auth/permissionConfig': typeof AuthPermissionConfigRoute
  '/_auth/postreceiver': typeof AuthPostreceiverRoute
  '/_auth/qualityAddress': typeof AuthQualityAddressRoute
  '/_auth/qualityMember': typeof AuthQualityMemberRoute
  '/_auth/registration': typeof AuthRegistrationRoute
  '/_auth/reports': typeof AuthReportsRoute
  '/_auth/scoutcardRequests': typeof AuthScoutcardRequestsRoute
  '/_auth/scoutcards': typeof AuthScoutcardsRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/start': typeof AuthStartRoute
  '/_auth/switchOrganization': typeof AuthSwitchOrganizationRoute
  '/_auth/uploadMember': typeof AuthUploadMemberRoute
  '/approveMembershipRequest_/$membershipRequestCode': typeof ApproveMembershipRequestMembershipRequestCodeRoute
  '/downloadReport_/$reportUuid': typeof DownloadReportReportUuidRoute
  '/_auth/createMembershipRequest_/$membershipUuid': typeof AuthCreateMembershipRequestMembershipUuidRoute
  '/_auth/list_/$listHeaderUuid': typeof AuthListListHeaderUuidRoute
  '/_auth/member_/$memberUuid': typeof AuthMemberMemberUuidRouteWithChildren
  '/_auth/membership_/$membershipUuid': typeof AuthMembershipMembershipUuidRouteWithChildren
  '/_auth/membershiprequest_/$uuid': typeof AuthMembershiprequestUuidRoute
  '/_auth/organization_/$organizationUuid': typeof AuthOrganizationOrganizationUuidRouteWithChildren
  '/_auth/member_/$memberUuid/awards': typeof AuthMemberMemberUuidAwardsRoute
  '/_auth/member_/$memberUuid/contacts': typeof AuthMemberMemberUuidContactsRoute
  '/_auth/member_/$memberUuid/descriptions': typeof AuthMemberMemberUuidDescriptionsRoute
  '/_auth/member_/$memberUuid/dynamicFields': typeof AuthMemberMemberUuidDynamicFieldsRoute
  '/_auth/member_/$memberUuid/dynamicFieldsGrid': typeof AuthMemberMemberUuidDynamicFieldsGridRoute
  '/_auth/member_/$memberUuid/education': typeof AuthMemberMemberUuidEducationRoute
  '/_auth/member_/$memberUuid/images': typeof AuthMemberMemberUuidImagesRoute
  '/_auth/member_/$memberUuid/info': typeof AuthMemberMemberUuidInfoRoute
  '/_auth/member_/$memberUuid/jobs': typeof AuthMemberMemberUuidJobsRoute
  '/_auth/member_/$memberUuid/lists': typeof AuthMemberMemberUuidListsRoute
  '/_auth/member_/$memberUuid/main': typeof AuthMemberMemberUuidMainRoute
  '/_auth/member_/$memberUuid/membershipSettings': typeof AuthMemberMemberUuidMembershipSettingsRoute
  '/_auth/member_/$memberUuid/memberships': typeof AuthMemberMemberUuidMembershipsRoute
  '/_auth/member_/$memberUuid/permissions': typeof AuthMemberMemberUuidPermissionsRoute
  '/_auth/member_/$memberUuid/registrationRecords': typeof AuthMemberMemberUuidRegistrationRecordsRoute
  '/_auth/member_/$memberUuid/relations': typeof AuthMemberMemberUuidRelationsRoute
  '/_auth/member_/$memberUuid/revisions': typeof AuthMemberMemberUuidRevisionsRoute
  '/_auth/member_/$memberUuid/sections': typeof AuthMemberMemberUuidSectionsRoute
  '/_auth/member_/$memberUuid/user': typeof AuthMemberMemberUuidUserRoute
  '/_auth/membership_/$membershipUuid/main': typeof AuthMembershipMembershipUuidMainRoute
  '/_auth/organization_/$organizationUuid/awards': typeof AuthOrganizationOrganizationUuidAwardsRoute
  '/_auth/organization_/$organizationUuid/dsgvoRequest': typeof AuthOrganizationOrganizationUuidDsgvoRequestRoute
  '/_auth/organization_/$organizationUuid/dynamicFields': typeof AuthOrganizationOrganizationUuidDynamicFieldsRoute
  '/_auth/organization_/$organizationUuid/dynamicFieldsTable': typeof AuthOrganizationOrganizationUuidDynamicFieldsTableRoute
  '/_auth/organization_/$organizationUuid/education': typeof AuthOrganizationOrganizationUuidEducationRoute
  '/_auth/organization_/$organizationUuid/images': typeof AuthOrganizationOrganizationUuidImagesRoute
  '/_auth/organization_/$organizationUuid/info': typeof AuthOrganizationOrganizationUuidInfoRoute
  '/_auth/organization_/$organizationUuid/jobs': typeof AuthOrganizationOrganizationUuidJobsRoute
  '/_auth/organization_/$organizationUuid/main': typeof AuthOrganizationOrganizationUuidMainRoute
  '/_auth/organization_/$organizationUuid/membershipRequests': typeof AuthOrganizationOrganizationUuidMembershipRequestsRoute
  '/_auth/organization_/$organizationUuid/migrations': typeof AuthOrganizationOrganizationUuidMigrationsRoute
  '/_auth/organization_/$organizationUuid/payment': typeof AuthOrganizationOrganizationUuidPaymentRoute
  '/_auth/organization_/$organizationUuid/permissions': typeof AuthOrganizationOrganizationUuidPermissionsRoute
  '/_auth/organization_/$organizationUuid/revisions': typeof AuthOrganizationOrganizationUuidRevisionsRoute
  '/_auth/organization_/$organizationUuid/sectionTimes': typeof AuthOrganizationOrganizationUuidSectionTimesRoute
  '/_auth/organization_/$organizationUuid/sections': typeof AuthOrganizationOrganizationUuidSectionsRoute
  '/_auth/member_/$memberUuid/memberaward_/$uuid': typeof AuthMemberMemberUuidMemberawardUuidRoute
  '/_auth/member_/$memberUuid/memberjob_/$uuid': typeof AuthMemberMemberUuidMemberjobUuidRoute
  '/_auth/member_/$memberUuid/membersection_/$uuid': typeof AuthMemberMemberUuidMembersectionUuidRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/help'
    | '/logout'
    | '/selfServiceCreateUser'
    | '/awards'
    | '/begin'
    | '/birthdays'
    | '/bulkUpdateSection'
    | '/calendar'
    | '/charts'
    | '/createMember'
    | '/education'
    | '/educationImport'
    | '/gildeReports'
    | '/grinsExports'
    | '/grinsView'
    | '/listMemberPivot'
    | '/lists'
    | '/medusaImport'
    | '/memberships'
    | '/membershipsOverview'
    | '/organizationHierarchy'
    | '/permissionConfig'
    | '/postreceiver'
    | '/qualityAddress'
    | '/qualityMember'
    | '/registration'
    | '/reports'
    | '/scoutcardRequests'
    | '/scoutcards'
    | '/settings'
    | '/start'
    | '/switchOrganization'
    | '/uploadMember'
    | '/approveMembershipRequest/$membershipRequestCode'
    | '/downloadReport/$reportUuid'
    | '/createMembershipRequest/$membershipUuid'
    | '/list/$listHeaderUuid'
    | '/member/$memberUuid'
    | '/membership/$membershipUuid'
    | '/membershiprequest/$uuid'
    | '/organization/$organizationUuid'
    | '/member/$memberUuid/awards'
    | '/member/$memberUuid/contacts'
    | '/member/$memberUuid/descriptions'
    | '/member/$memberUuid/dynamicFields'
    | '/member/$memberUuid/dynamicFieldsGrid'
    | '/member/$memberUuid/education'
    | '/member/$memberUuid/images'
    | '/member/$memberUuid/info'
    | '/member/$memberUuid/jobs'
    | '/member/$memberUuid/lists'
    | '/member/$memberUuid/main'
    | '/member/$memberUuid/membershipSettings'
    | '/member/$memberUuid/memberships'
    | '/member/$memberUuid/permissions'
    | '/member/$memberUuid/registrationRecords'
    | '/member/$memberUuid/relations'
    | '/member/$memberUuid/revisions'
    | '/member/$memberUuid/sections'
    | '/member/$memberUuid/user'
    | '/membership/$membershipUuid/main'
    | '/organization/$organizationUuid/awards'
    | '/organization/$organizationUuid/dsgvoRequest'
    | '/organization/$organizationUuid/dynamicFields'
    | '/organization/$organizationUuid/dynamicFieldsTable'
    | '/organization/$organizationUuid/education'
    | '/organization/$organizationUuid/images'
    | '/organization/$organizationUuid/info'
    | '/organization/$organizationUuid/jobs'
    | '/organization/$organizationUuid/main'
    | '/organization/$organizationUuid/membershipRequests'
    | '/organization/$organizationUuid/migrations'
    | '/organization/$organizationUuid/payment'
    | '/organization/$organizationUuid/permissions'
    | '/organization/$organizationUuid/revisions'
    | '/organization/$organizationUuid/sectionTimes'
    | '/organization/$organizationUuid/sections'
    | '/member/$memberUuid/memberaward/$uuid'
    | '/member/$memberUuid/memberjob/$uuid'
    | '/member/$memberUuid/membersection/$uuid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/help'
    | '/logout'
    | '/selfServiceCreateUser'
    | '/awards'
    | '/begin'
    | '/birthdays'
    | '/bulkUpdateSection'
    | '/calendar'
    | '/charts'
    | '/createMember'
    | '/education'
    | '/educationImport'
    | '/gildeReports'
    | '/grinsExports'
    | '/grinsView'
    | '/listMemberPivot'
    | '/lists'
    | '/medusaImport'
    | '/memberships'
    | '/membershipsOverview'
    | '/organizationHierarchy'
    | '/permissionConfig'
    | '/postreceiver'
    | '/qualityAddress'
    | '/qualityMember'
    | '/registration'
    | '/reports'
    | '/scoutcardRequests'
    | '/scoutcards'
    | '/settings'
    | '/start'
    | '/switchOrganization'
    | '/uploadMember'
    | '/approveMembershipRequest/$membershipRequestCode'
    | '/downloadReport/$reportUuid'
    | '/createMembershipRequest/$membershipUuid'
    | '/list/$listHeaderUuid'
    | '/member/$memberUuid'
    | '/membership/$membershipUuid'
    | '/membershiprequest/$uuid'
    | '/organization/$organizationUuid'
    | '/member/$memberUuid/awards'
    | '/member/$memberUuid/contacts'
    | '/member/$memberUuid/descriptions'
    | '/member/$memberUuid/dynamicFields'
    | '/member/$memberUuid/dynamicFieldsGrid'
    | '/member/$memberUuid/education'
    | '/member/$memberUuid/images'
    | '/member/$memberUuid/info'
    | '/member/$memberUuid/jobs'
    | '/member/$memberUuid/lists'
    | '/member/$memberUuid/main'
    | '/member/$memberUuid/membershipSettings'
    | '/member/$memberUuid/memberships'
    | '/member/$memberUuid/permissions'
    | '/member/$memberUuid/registrationRecords'
    | '/member/$memberUuid/relations'
    | '/member/$memberUuid/revisions'
    | '/member/$memberUuid/sections'
    | '/member/$memberUuid/user'
    | '/membership/$membershipUuid/main'
    | '/organization/$organizationUuid/awards'
    | '/organization/$organizationUuid/dsgvoRequest'
    | '/organization/$organizationUuid/dynamicFields'
    | '/organization/$organizationUuid/dynamicFieldsTable'
    | '/organization/$organizationUuid/education'
    | '/organization/$organizationUuid/images'
    | '/organization/$organizationUuid/info'
    | '/organization/$organizationUuid/jobs'
    | '/organization/$organizationUuid/main'
    | '/organization/$organizationUuid/membershipRequests'
    | '/organization/$organizationUuid/migrations'
    | '/organization/$organizationUuid/payment'
    | '/organization/$organizationUuid/permissions'
    | '/organization/$organizationUuid/revisions'
    | '/organization/$organizationUuid/sectionTimes'
    | '/organization/$organizationUuid/sections'
    | '/member/$memberUuid/memberaward/$uuid'
    | '/member/$memberUuid/memberjob/$uuid'
    | '/member/$memberUuid/membersection/$uuid'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/help'
    | '/logout'
    | '/selfServiceCreateUser'
    | '/_auth/awards'
    | '/_auth/begin'
    | '/_auth/birthdays'
    | '/_auth/bulkUpdateSection'
    | '/_auth/calendar'
    | '/_auth/charts'
    | '/_auth/createMember'
    | '/_auth/education'
    | '/_auth/educationImport'
    | '/_auth/gildeReports'
    | '/_auth/grinsExports'
    | '/_auth/grinsView'
    | '/_auth/listMemberPivot'
    | '/_auth/lists'
    | '/_auth/medusaImport'
    | '/_auth/memberships'
    | '/_auth/membershipsOverview'
    | '/_auth/organizationHierarchy'
    | '/_auth/permissionConfig'
    | '/_auth/postreceiver'
    | '/_auth/qualityAddress'
    | '/_auth/qualityMember'
    | '/_auth/registration'
    | '/_auth/reports'
    | '/_auth/scoutcardRequests'
    | '/_auth/scoutcards'
    | '/_auth/settings'
    | '/_auth/start'
    | '/_auth/switchOrganization'
    | '/_auth/uploadMember'
    | '/approveMembershipRequest_/$membershipRequestCode'
    | '/downloadReport_/$reportUuid'
    | '/_auth/createMembershipRequest_/$membershipUuid'
    | '/_auth/list_/$listHeaderUuid'
    | '/_auth/member_/$memberUuid'
    | '/_auth/membership_/$membershipUuid'
    | '/_auth/membershiprequest_/$uuid'
    | '/_auth/organization_/$organizationUuid'
    | '/_auth/member_/$memberUuid/awards'
    | '/_auth/member_/$memberUuid/contacts'
    | '/_auth/member_/$memberUuid/descriptions'
    | '/_auth/member_/$memberUuid/dynamicFields'
    | '/_auth/member_/$memberUuid/dynamicFieldsGrid'
    | '/_auth/member_/$memberUuid/education'
    | '/_auth/member_/$memberUuid/images'
    | '/_auth/member_/$memberUuid/info'
    | '/_auth/member_/$memberUuid/jobs'
    | '/_auth/member_/$memberUuid/lists'
    | '/_auth/member_/$memberUuid/main'
    | '/_auth/member_/$memberUuid/membershipSettings'
    | '/_auth/member_/$memberUuid/memberships'
    | '/_auth/member_/$memberUuid/permissions'
    | '/_auth/member_/$memberUuid/registrationRecords'
    | '/_auth/member_/$memberUuid/relations'
    | '/_auth/member_/$memberUuid/revisions'
    | '/_auth/member_/$memberUuid/sections'
    | '/_auth/member_/$memberUuid/user'
    | '/_auth/membership_/$membershipUuid/main'
    | '/_auth/organization_/$organizationUuid/awards'
    | '/_auth/organization_/$organizationUuid/dsgvoRequest'
    | '/_auth/organization_/$organizationUuid/dynamicFields'
    | '/_auth/organization_/$organizationUuid/dynamicFieldsTable'
    | '/_auth/organization_/$organizationUuid/education'
    | '/_auth/organization_/$organizationUuid/images'
    | '/_auth/organization_/$organizationUuid/info'
    | '/_auth/organization_/$organizationUuid/jobs'
    | '/_auth/organization_/$organizationUuid/main'
    | '/_auth/organization_/$organizationUuid/membershipRequests'
    | '/_auth/organization_/$organizationUuid/migrations'
    | '/_auth/organization_/$organizationUuid/payment'
    | '/_auth/organization_/$organizationUuid/permissions'
    | '/_auth/organization_/$organizationUuid/revisions'
    | '/_auth/organization_/$organizationUuid/sectionTimes'
    | '/_auth/organization_/$organizationUuid/sections'
    | '/_auth/member_/$memberUuid/memberaward_/$uuid'
    | '/_auth/member_/$memberUuid/memberjob_/$uuid'
    | '/_auth/member_/$memberUuid/membersection_/$uuid'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  HelpRoute: typeof HelpRoute
  LogoutRoute: typeof LogoutRoute
  SelfServiceCreateUserRoute: typeof SelfServiceCreateUserRoute
  ApproveMembershipRequestMembershipRequestCodeRoute: typeof ApproveMembershipRequestMembershipRequestCodeRoute
  DownloadReportReportUuidRoute: typeof DownloadReportReportUuidRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/selfServiceCreateUser': {
      id: '/selfServiceCreateUser'
      path: '/selfServiceCreateUser'
      fullPath: '/selfServiceCreateUser'
      preLoaderRoute: typeof SelfServiceCreateUserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/awards': {
      id: '/_auth/awards'
      path: '/awards'
      fullPath: '/awards'
      preLoaderRoute: typeof AuthAwardsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/begin': {
      id: '/_auth/begin'
      path: '/begin'
      fullPath: '/begin'
      preLoaderRoute: typeof AuthBeginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/birthdays': {
      id: '/_auth/birthdays'
      path: '/birthdays'
      fullPath: '/birthdays'
      preLoaderRoute: typeof AuthBirthdaysRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bulkUpdateSection': {
      id: '/_auth/bulkUpdateSection'
      path: '/bulkUpdateSection'
      fullPath: '/bulkUpdateSection'
      preLoaderRoute: typeof AuthBulkUpdateSectionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/calendar': {
      id: '/_auth/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthCalendarRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/charts': {
      id: '/_auth/charts'
      path: '/charts'
      fullPath: '/charts'
      preLoaderRoute: typeof AuthChartsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/createMember': {
      id: '/_auth/createMember'
      path: '/createMember'
      fullPath: '/createMember'
      preLoaderRoute: typeof AuthCreateMemberRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/education': {
      id: '/_auth/education'
      path: '/education'
      fullPath: '/education'
      preLoaderRoute: typeof AuthEducationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/educationImport': {
      id: '/_auth/educationImport'
      path: '/educationImport'
      fullPath: '/educationImport'
      preLoaderRoute: typeof AuthEducationImportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/gildeReports': {
      id: '/_auth/gildeReports'
      path: '/gildeReports'
      fullPath: '/gildeReports'
      preLoaderRoute: typeof AuthGildeReportsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/grinsExports': {
      id: '/_auth/grinsExports'
      path: '/grinsExports'
      fullPath: '/grinsExports'
      preLoaderRoute: typeof AuthGrinsExportsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/grinsView': {
      id: '/_auth/grinsView'
      path: '/grinsView'
      fullPath: '/grinsView'
      preLoaderRoute: typeof AuthGrinsViewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/listMemberPivot': {
      id: '/_auth/listMemberPivot'
      path: '/listMemberPivot'
      fullPath: '/listMemberPivot'
      preLoaderRoute: typeof AuthListMemberPivotRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/lists': {
      id: '/_auth/lists'
      path: '/lists'
      fullPath: '/lists'
      preLoaderRoute: typeof AuthListsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/medusaImport': {
      id: '/_auth/medusaImport'
      path: '/medusaImport'
      fullPath: '/medusaImport'
      preLoaderRoute: typeof AuthMedusaImportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/memberships': {
      id: '/_auth/memberships'
      path: '/memberships'
      fullPath: '/memberships'
      preLoaderRoute: typeof AuthMembershipsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/membershipsOverview': {
      id: '/_auth/membershipsOverview'
      path: '/membershipsOverview'
      fullPath: '/membershipsOverview'
      preLoaderRoute: typeof AuthMembershipsOverviewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/organizationHierarchy': {
      id: '/_auth/organizationHierarchy'
      path: '/organizationHierarchy'
      fullPath: '/organizationHierarchy'
      preLoaderRoute: typeof AuthOrganizationHierarchyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/permissionConfig': {
      id: '/_auth/permissionConfig'
      path: '/permissionConfig'
      fullPath: '/permissionConfig'
      preLoaderRoute: typeof AuthPermissionConfigRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/postreceiver': {
      id: '/_auth/postreceiver'
      path: '/postreceiver'
      fullPath: '/postreceiver'
      preLoaderRoute: typeof AuthPostreceiverRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/qualityAddress': {
      id: '/_auth/qualityAddress'
      path: '/qualityAddress'
      fullPath: '/qualityAddress'
      preLoaderRoute: typeof AuthQualityAddressRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/qualityMember': {
      id: '/_auth/qualityMember'
      path: '/qualityMember'
      fullPath: '/qualityMember'
      preLoaderRoute: typeof AuthQualityMemberRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/registration': {
      id: '/_auth/registration'
      path: '/registration'
      fullPath: '/registration'
      preLoaderRoute: typeof AuthRegistrationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports': {
      id: '/_auth/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthReportsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/scoutcardRequests': {
      id: '/_auth/scoutcardRequests'
      path: '/scoutcardRequests'
      fullPath: '/scoutcardRequests'
      preLoaderRoute: typeof AuthScoutcardRequestsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/scoutcards': {
      id: '/_auth/scoutcards'
      path: '/scoutcards'
      fullPath: '/scoutcards'
      preLoaderRoute: typeof AuthScoutcardsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/start': {
      id: '/_auth/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof AuthStartRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/switchOrganization': {
      id: '/_auth/switchOrganization'
      path: '/switchOrganization'
      fullPath: '/switchOrganization'
      preLoaderRoute: typeof AuthSwitchOrganizationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/uploadMember': {
      id: '/_auth/uploadMember'
      path: '/uploadMember'
      fullPath: '/uploadMember'
      preLoaderRoute: typeof AuthUploadMemberRouteImport
      parentRoute: typeof AuthRoute
    }
    '/approveMembershipRequest_/$membershipRequestCode': {
      id: '/approveMembershipRequest_/$membershipRequestCode'
      path: '/approveMembershipRequest/$membershipRequestCode'
      fullPath: '/approveMembershipRequest/$membershipRequestCode'
      preLoaderRoute: typeof ApproveMembershipRequestMembershipRequestCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/downloadReport_/$reportUuid': {
      id: '/downloadReport_/$reportUuid'
      path: '/downloadReport/$reportUuid'
      fullPath: '/downloadReport/$reportUuid'
      preLoaderRoute: typeof DownloadReportReportUuidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/createMembershipRequest_/$membershipUuid': {
      id: '/_auth/createMembershipRequest_/$membershipUuid'
      path: '/createMembershipRequest/$membershipUuid'
      fullPath: '/createMembershipRequest/$membershipUuid'
      preLoaderRoute: typeof AuthCreateMembershipRequestMembershipUuidRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/list_/$listHeaderUuid': {
      id: '/_auth/list_/$listHeaderUuid'
      path: '/list/$listHeaderUuid'
      fullPath: '/list/$listHeaderUuid'
      preLoaderRoute: typeof AuthListListHeaderUuidRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/member_/$memberUuid': {
      id: '/_auth/member_/$memberUuid'
      path: '/member/$memberUuid'
      fullPath: '/member/$memberUuid'
      preLoaderRoute: typeof AuthMemberMemberUuidRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/membership_/$membershipUuid': {
      id: '/_auth/membership_/$membershipUuid'
      path: '/membership/$membershipUuid'
      fullPath: '/membership/$membershipUuid'
      preLoaderRoute: typeof AuthMembershipMembershipUuidRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/membershiprequest_/$uuid': {
      id: '/_auth/membershiprequest_/$uuid'
      path: '/membershiprequest/$uuid'
      fullPath: '/membershiprequest/$uuid'
      preLoaderRoute: typeof AuthMembershiprequestUuidRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/organization_/$organizationUuid': {
      id: '/_auth/organization_/$organizationUuid'
      path: '/organization/$organizationUuid'
      fullPath: '/organization/$organizationUuid'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/member_/$memberUuid/awards': {
      id: '/_auth/member_/$memberUuid/awards'
      path: '/awards'
      fullPath: '/member/$memberUuid/awards'
      preLoaderRoute: typeof AuthMemberMemberUuidAwardsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/contacts': {
      id: '/_auth/member_/$memberUuid/contacts'
      path: '/contacts'
      fullPath: '/member/$memberUuid/contacts'
      preLoaderRoute: typeof AuthMemberMemberUuidContactsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/descriptions': {
      id: '/_auth/member_/$memberUuid/descriptions'
      path: '/descriptions'
      fullPath: '/member/$memberUuid/descriptions'
      preLoaderRoute: typeof AuthMemberMemberUuidDescriptionsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/dynamicFields': {
      id: '/_auth/member_/$memberUuid/dynamicFields'
      path: '/dynamicFields'
      fullPath: '/member/$memberUuid/dynamicFields'
      preLoaderRoute: typeof AuthMemberMemberUuidDynamicFieldsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/dynamicFieldsGrid': {
      id: '/_auth/member_/$memberUuid/dynamicFieldsGrid'
      path: '/dynamicFieldsGrid'
      fullPath: '/member/$memberUuid/dynamicFieldsGrid'
      preLoaderRoute: typeof AuthMemberMemberUuidDynamicFieldsGridRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/education': {
      id: '/_auth/member_/$memberUuid/education'
      path: '/education'
      fullPath: '/member/$memberUuid/education'
      preLoaderRoute: typeof AuthMemberMemberUuidEducationRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/images': {
      id: '/_auth/member_/$memberUuid/images'
      path: '/images'
      fullPath: '/member/$memberUuid/images'
      preLoaderRoute: typeof AuthMemberMemberUuidImagesRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/info': {
      id: '/_auth/member_/$memberUuid/info'
      path: '/info'
      fullPath: '/member/$memberUuid/info'
      preLoaderRoute: typeof AuthMemberMemberUuidInfoRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/jobs': {
      id: '/_auth/member_/$memberUuid/jobs'
      path: '/jobs'
      fullPath: '/member/$memberUuid/jobs'
      preLoaderRoute: typeof AuthMemberMemberUuidJobsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/lists': {
      id: '/_auth/member_/$memberUuid/lists'
      path: '/lists'
      fullPath: '/member/$memberUuid/lists'
      preLoaderRoute: typeof AuthMemberMemberUuidListsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/main': {
      id: '/_auth/member_/$memberUuid/main'
      path: '/main'
      fullPath: '/member/$memberUuid/main'
      preLoaderRoute: typeof AuthMemberMemberUuidMainRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/membershipSettings': {
      id: '/_auth/member_/$memberUuid/membershipSettings'
      path: '/membershipSettings'
      fullPath: '/member/$memberUuid/membershipSettings'
      preLoaderRoute: typeof AuthMemberMemberUuidMembershipSettingsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/memberships': {
      id: '/_auth/member_/$memberUuid/memberships'
      path: '/memberships'
      fullPath: '/member/$memberUuid/memberships'
      preLoaderRoute: typeof AuthMemberMemberUuidMembershipsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/permissions': {
      id: '/_auth/member_/$memberUuid/permissions'
      path: '/permissions'
      fullPath: '/member/$memberUuid/permissions'
      preLoaderRoute: typeof AuthMemberMemberUuidPermissionsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/registrationRecords': {
      id: '/_auth/member_/$memberUuid/registrationRecords'
      path: '/registrationRecords'
      fullPath: '/member/$memberUuid/registrationRecords'
      preLoaderRoute: typeof AuthMemberMemberUuidRegistrationRecordsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/relations': {
      id: '/_auth/member_/$memberUuid/relations'
      path: '/relations'
      fullPath: '/member/$memberUuid/relations'
      preLoaderRoute: typeof AuthMemberMemberUuidRelationsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/revisions': {
      id: '/_auth/member_/$memberUuid/revisions'
      path: '/revisions'
      fullPath: '/member/$memberUuid/revisions'
      preLoaderRoute: typeof AuthMemberMemberUuidRevisionsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/sections': {
      id: '/_auth/member_/$memberUuid/sections'
      path: '/sections'
      fullPath: '/member/$memberUuid/sections'
      preLoaderRoute: typeof AuthMemberMemberUuidSectionsRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/user': {
      id: '/_auth/member_/$memberUuid/user'
      path: '/user'
      fullPath: '/member/$memberUuid/user'
      preLoaderRoute: typeof AuthMemberMemberUuidUserRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/membership_/$membershipUuid/main': {
      id: '/_auth/membership_/$membershipUuid/main'
      path: '/main'
      fullPath: '/membership/$membershipUuid/main'
      preLoaderRoute: typeof AuthMembershipMembershipUuidMainRouteImport
      parentRoute: typeof AuthMembershipMembershipUuidRoute
    }
    '/_auth/organization_/$organizationUuid/awards': {
      id: '/_auth/organization_/$organizationUuid/awards'
      path: '/awards'
      fullPath: '/organization/$organizationUuid/awards'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidAwardsRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/dsgvoRequest': {
      id: '/_auth/organization_/$organizationUuid/dsgvoRequest'
      path: '/dsgvoRequest'
      fullPath: '/organization/$organizationUuid/dsgvoRequest'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidDsgvoRequestRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/dynamicFields': {
      id: '/_auth/organization_/$organizationUuid/dynamicFields'
      path: '/dynamicFields'
      fullPath: '/organization/$organizationUuid/dynamicFields'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidDynamicFieldsRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/dynamicFieldsTable': {
      id: '/_auth/organization_/$organizationUuid/dynamicFieldsTable'
      path: '/dynamicFieldsTable'
      fullPath: '/organization/$organizationUuid/dynamicFieldsTable'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidDynamicFieldsTableRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/education': {
      id: '/_auth/organization_/$organizationUuid/education'
      path: '/education'
      fullPath: '/organization/$organizationUuid/education'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidEducationRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/images': {
      id: '/_auth/organization_/$organizationUuid/images'
      path: '/images'
      fullPath: '/organization/$organizationUuid/images'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidImagesRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/info': {
      id: '/_auth/organization_/$organizationUuid/info'
      path: '/info'
      fullPath: '/organization/$organizationUuid/info'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidInfoRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/jobs': {
      id: '/_auth/organization_/$organizationUuid/jobs'
      path: '/jobs'
      fullPath: '/organization/$organizationUuid/jobs'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidJobsRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/main': {
      id: '/_auth/organization_/$organizationUuid/main'
      path: '/main'
      fullPath: '/organization/$organizationUuid/main'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidMainRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/membershipRequests': {
      id: '/_auth/organization_/$organizationUuid/membershipRequests'
      path: '/membershipRequests'
      fullPath: '/organization/$organizationUuid/membershipRequests'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidMembershipRequestsRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/migrations': {
      id: '/_auth/organization_/$organizationUuid/migrations'
      path: '/migrations'
      fullPath: '/organization/$organizationUuid/migrations'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidMigrationsRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/payment': {
      id: '/_auth/organization_/$organizationUuid/payment'
      path: '/payment'
      fullPath: '/organization/$organizationUuid/payment'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidPaymentRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/permissions': {
      id: '/_auth/organization_/$organizationUuid/permissions'
      path: '/permissions'
      fullPath: '/organization/$organizationUuid/permissions'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidPermissionsRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/revisions': {
      id: '/_auth/organization_/$organizationUuid/revisions'
      path: '/revisions'
      fullPath: '/organization/$organizationUuid/revisions'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidRevisionsRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/sectionTimes': {
      id: '/_auth/organization_/$organizationUuid/sectionTimes'
      path: '/sectionTimes'
      fullPath: '/organization/$organizationUuid/sectionTimes'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidSectionTimesRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/organization_/$organizationUuid/sections': {
      id: '/_auth/organization_/$organizationUuid/sections'
      path: '/sections'
      fullPath: '/organization/$organizationUuid/sections'
      preLoaderRoute: typeof AuthOrganizationOrganizationUuidSectionsRouteImport
      parentRoute: typeof AuthOrganizationOrganizationUuidRoute
    }
    '/_auth/member_/$memberUuid/memberaward_/$uuid': {
      id: '/_auth/member_/$memberUuid/memberaward_/$uuid'
      path: '/memberaward/$uuid'
      fullPath: '/member/$memberUuid/memberaward/$uuid'
      preLoaderRoute: typeof AuthMemberMemberUuidMemberawardUuidRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/memberjob_/$uuid': {
      id: '/_auth/member_/$memberUuid/memberjob_/$uuid'
      path: '/memberjob/$uuid'
      fullPath: '/member/$memberUuid/memberjob/$uuid'
      preLoaderRoute: typeof AuthMemberMemberUuidMemberjobUuidRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
    '/_auth/member_/$memberUuid/membersection_/$uuid': {
      id: '/_auth/member_/$memberUuid/membersection_/$uuid'
      path: '/membersection/$uuid'
      fullPath: '/member/$memberUuid/membersection/$uuid'
      preLoaderRoute: typeof AuthMemberMemberUuidMembersectionUuidRouteImport
      parentRoute: typeof AuthMemberMemberUuidRoute
    }
  }
}

interface AuthMemberMemberUuidRouteChildren {
  AuthMemberMemberUuidAwardsRoute: typeof AuthMemberMemberUuidAwardsRoute
  AuthMemberMemberUuidContactsRoute: typeof AuthMemberMemberUuidContactsRoute
  AuthMemberMemberUuidDescriptionsRoute: typeof AuthMemberMemberUuidDescriptionsRoute
  AuthMemberMemberUuidDynamicFieldsRoute: typeof AuthMemberMemberUuidDynamicFieldsRoute
  AuthMemberMemberUuidDynamicFieldsGridRoute: typeof AuthMemberMemberUuidDynamicFieldsGridRoute
  AuthMemberMemberUuidEducationRoute: typeof AuthMemberMemberUuidEducationRoute
  AuthMemberMemberUuidImagesRoute: typeof AuthMemberMemberUuidImagesRoute
  AuthMemberMemberUuidInfoRoute: typeof AuthMemberMemberUuidInfoRoute
  AuthMemberMemberUuidJobsRoute: typeof AuthMemberMemberUuidJobsRoute
  AuthMemberMemberUuidListsRoute: typeof AuthMemberMemberUuidListsRoute
  AuthMemberMemberUuidMainRoute: typeof AuthMemberMemberUuidMainRoute
  AuthMemberMemberUuidMembershipSettingsRoute: typeof AuthMemberMemberUuidMembershipSettingsRoute
  AuthMemberMemberUuidMembershipsRoute: typeof AuthMemberMemberUuidMembershipsRoute
  AuthMemberMemberUuidPermissionsRoute: typeof AuthMemberMemberUuidPermissionsRoute
  AuthMemberMemberUuidRegistrationRecordsRoute: typeof AuthMemberMemberUuidRegistrationRecordsRoute
  AuthMemberMemberUuidRelationsRoute: typeof AuthMemberMemberUuidRelationsRoute
  AuthMemberMemberUuidRevisionsRoute: typeof AuthMemberMemberUuidRevisionsRoute
  AuthMemberMemberUuidSectionsRoute: typeof AuthMemberMemberUuidSectionsRoute
  AuthMemberMemberUuidUserRoute: typeof AuthMemberMemberUuidUserRoute
  AuthMemberMemberUuidMemberawardUuidRoute: typeof AuthMemberMemberUuidMemberawardUuidRoute
  AuthMemberMemberUuidMemberjobUuidRoute: typeof AuthMemberMemberUuidMemberjobUuidRoute
  AuthMemberMemberUuidMembersectionUuidRoute: typeof AuthMemberMemberUuidMembersectionUuidRoute
}

const AuthMemberMemberUuidRouteChildren: AuthMemberMemberUuidRouteChildren = {
  AuthMemberMemberUuidAwardsRoute: AuthMemberMemberUuidAwardsRoute,
  AuthMemberMemberUuidContactsRoute: AuthMemberMemberUuidContactsRoute,
  AuthMemberMemberUuidDescriptionsRoute: AuthMemberMemberUuidDescriptionsRoute,
  AuthMemberMemberUuidDynamicFieldsRoute:
    AuthMemberMemberUuidDynamicFieldsRoute,
  AuthMemberMemberUuidDynamicFieldsGridRoute:
    AuthMemberMemberUuidDynamicFieldsGridRoute,
  AuthMemberMemberUuidEducationRoute: AuthMemberMemberUuidEducationRoute,
  AuthMemberMemberUuidImagesRoute: AuthMemberMemberUuidImagesRoute,
  AuthMemberMemberUuidInfoRoute: AuthMemberMemberUuidInfoRoute,
  AuthMemberMemberUuidJobsRoute: AuthMemberMemberUuidJobsRoute,
  AuthMemberMemberUuidListsRoute: AuthMemberMemberUuidListsRoute,
  AuthMemberMemberUuidMainRoute: AuthMemberMemberUuidMainRoute,
  AuthMemberMemberUuidMembershipSettingsRoute:
    AuthMemberMemberUuidMembershipSettingsRoute,
  AuthMemberMemberUuidMembershipsRoute: AuthMemberMemberUuidMembershipsRoute,
  AuthMemberMemberUuidPermissionsRoute: AuthMemberMemberUuidPermissionsRoute,
  AuthMemberMemberUuidRegistrationRecordsRoute:
    AuthMemberMemberUuidRegistrationRecordsRoute,
  AuthMemberMemberUuidRelationsRoute: AuthMemberMemberUuidRelationsRoute,
  AuthMemberMemberUuidRevisionsRoute: AuthMemberMemberUuidRevisionsRoute,
  AuthMemberMemberUuidSectionsRoute: AuthMemberMemberUuidSectionsRoute,
  AuthMemberMemberUuidUserRoute: AuthMemberMemberUuidUserRoute,
  AuthMemberMemberUuidMemberawardUuidRoute:
    AuthMemberMemberUuidMemberawardUuidRoute,
  AuthMemberMemberUuidMemberjobUuidRoute:
    AuthMemberMemberUuidMemberjobUuidRoute,
  AuthMemberMemberUuidMembersectionUuidRoute:
    AuthMemberMemberUuidMembersectionUuidRoute,
}

const AuthMemberMemberUuidRouteWithChildren =
  AuthMemberMemberUuidRoute._addFileChildren(AuthMemberMemberUuidRouteChildren)

interface AuthMembershipMembershipUuidRouteChildren {
  AuthMembershipMembershipUuidMainRoute: typeof AuthMembershipMembershipUuidMainRoute
}

const AuthMembershipMembershipUuidRouteChildren: AuthMembershipMembershipUuidRouteChildren =
  {
    AuthMembershipMembershipUuidMainRoute:
      AuthMembershipMembershipUuidMainRoute,
  }

const AuthMembershipMembershipUuidRouteWithChildren =
  AuthMembershipMembershipUuidRoute._addFileChildren(
    AuthMembershipMembershipUuidRouteChildren,
  )

interface AuthOrganizationOrganizationUuidRouteChildren {
  AuthOrganizationOrganizationUuidAwardsRoute: typeof AuthOrganizationOrganizationUuidAwardsRoute
  AuthOrganizationOrganizationUuidDsgvoRequestRoute: typeof AuthOrganizationOrganizationUuidDsgvoRequestRoute
  AuthOrganizationOrganizationUuidDynamicFieldsRoute: typeof AuthOrganizationOrganizationUuidDynamicFieldsRoute
  AuthOrganizationOrganizationUuidDynamicFieldsTableRoute: typeof AuthOrganizationOrganizationUuidDynamicFieldsTableRoute
  AuthOrganizationOrganizationUuidEducationRoute: typeof AuthOrganizationOrganizationUuidEducationRoute
  AuthOrganizationOrganizationUuidImagesRoute: typeof AuthOrganizationOrganizationUuidImagesRoute
  AuthOrganizationOrganizationUuidInfoRoute: typeof AuthOrganizationOrganizationUuidInfoRoute
  AuthOrganizationOrganizationUuidJobsRoute: typeof AuthOrganizationOrganizationUuidJobsRoute
  AuthOrganizationOrganizationUuidMainRoute: typeof AuthOrganizationOrganizationUuidMainRoute
  AuthOrganizationOrganizationUuidMembershipRequestsRoute: typeof AuthOrganizationOrganizationUuidMembershipRequestsRoute
  AuthOrganizationOrganizationUuidMigrationsRoute: typeof AuthOrganizationOrganizationUuidMigrationsRoute
  AuthOrganizationOrganizationUuidPaymentRoute: typeof AuthOrganizationOrganizationUuidPaymentRoute
  AuthOrganizationOrganizationUuidPermissionsRoute: typeof AuthOrganizationOrganizationUuidPermissionsRoute
  AuthOrganizationOrganizationUuidRevisionsRoute: typeof AuthOrganizationOrganizationUuidRevisionsRoute
  AuthOrganizationOrganizationUuidSectionTimesRoute: typeof AuthOrganizationOrganizationUuidSectionTimesRoute
  AuthOrganizationOrganizationUuidSectionsRoute: typeof AuthOrganizationOrganizationUuidSectionsRoute
}

const AuthOrganizationOrganizationUuidRouteChildren: AuthOrganizationOrganizationUuidRouteChildren =
  {
    AuthOrganizationOrganizationUuidAwardsRoute:
      AuthOrganizationOrganizationUuidAwardsRoute,
    AuthOrganizationOrganizationUuidDsgvoRequestRoute:
      AuthOrganizationOrganizationUuidDsgvoRequestRoute,
    AuthOrganizationOrganizationUuidDynamicFieldsRoute:
      AuthOrganizationOrganizationUuidDynamicFieldsRoute,
    AuthOrganizationOrganizationUuidDynamicFieldsTableRoute:
      AuthOrganizationOrganizationUuidDynamicFieldsTableRoute,
    AuthOrganizationOrganizationUuidEducationRoute:
      AuthOrganizationOrganizationUuidEducationRoute,
    AuthOrganizationOrganizationUuidImagesRoute:
      AuthOrganizationOrganizationUuidImagesRoute,
    AuthOrganizationOrganizationUuidInfoRoute:
      AuthOrganizationOrganizationUuidInfoRoute,
    AuthOrganizationOrganizationUuidJobsRoute:
      AuthOrganizationOrganizationUuidJobsRoute,
    AuthOrganizationOrganizationUuidMainRoute:
      AuthOrganizationOrganizationUuidMainRoute,
    AuthOrganizationOrganizationUuidMembershipRequestsRoute:
      AuthOrganizationOrganizationUuidMembershipRequestsRoute,
    AuthOrganizationOrganizationUuidMigrationsRoute:
      AuthOrganizationOrganizationUuidMigrationsRoute,
    AuthOrganizationOrganizationUuidPaymentRoute:
      AuthOrganizationOrganizationUuidPaymentRoute,
    AuthOrganizationOrganizationUuidPermissionsRoute:
      AuthOrganizationOrganizationUuidPermissionsRoute,
    AuthOrganizationOrganizationUuidRevisionsRoute:
      AuthOrganizationOrganizationUuidRevisionsRoute,
    AuthOrganizationOrganizationUuidSectionTimesRoute:
      AuthOrganizationOrganizationUuidSectionTimesRoute,
    AuthOrganizationOrganizationUuidSectionsRoute:
      AuthOrganizationOrganizationUuidSectionsRoute,
  }

const AuthOrganizationOrganizationUuidRouteWithChildren =
  AuthOrganizationOrganizationUuidRoute._addFileChildren(
    AuthOrganizationOrganizationUuidRouteChildren,
  )

interface AuthRouteChildren {
  AuthAwardsRoute: typeof AuthAwardsRoute
  AuthBeginRoute: typeof AuthBeginRoute
  AuthBirthdaysRoute: typeof AuthBirthdaysRoute
  AuthBulkUpdateSectionRoute: typeof AuthBulkUpdateSectionRoute
  AuthCalendarRoute: typeof AuthCalendarRoute
  AuthChartsRoute: typeof AuthChartsRoute
  AuthCreateMemberRoute: typeof AuthCreateMemberRoute
  AuthEducationRoute: typeof AuthEducationRoute
  AuthEducationImportRoute: typeof AuthEducationImportRoute
  AuthGildeReportsRoute: typeof AuthGildeReportsRoute
  AuthGrinsExportsRoute: typeof AuthGrinsExportsRoute
  AuthGrinsViewRoute: typeof AuthGrinsViewRoute
  AuthListMemberPivotRoute: typeof AuthListMemberPivotRoute
  AuthListsRoute: typeof AuthListsRoute
  AuthMedusaImportRoute: typeof AuthMedusaImportRoute
  AuthMembershipsRoute: typeof AuthMembershipsRoute
  AuthMembershipsOverviewRoute: typeof AuthMembershipsOverviewRoute
  AuthOrganizationHierarchyRoute: typeof AuthOrganizationHierarchyRoute
  AuthPermissionConfigRoute: typeof AuthPermissionConfigRoute
  AuthPostreceiverRoute: typeof AuthPostreceiverRoute
  AuthQualityAddressRoute: typeof AuthQualityAddressRoute
  AuthQualityMemberRoute: typeof AuthQualityMemberRoute
  AuthRegistrationRoute: typeof AuthRegistrationRoute
  AuthReportsRoute: typeof AuthReportsRoute
  AuthScoutcardRequestsRoute: typeof AuthScoutcardRequestsRoute
  AuthScoutcardsRoute: typeof AuthScoutcardsRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthStartRoute: typeof AuthStartRoute
  AuthSwitchOrganizationRoute: typeof AuthSwitchOrganizationRoute
  AuthUploadMemberRoute: typeof AuthUploadMemberRoute
  AuthCreateMembershipRequestMembershipUuidRoute: typeof AuthCreateMembershipRequestMembershipUuidRoute
  AuthListListHeaderUuidRoute: typeof AuthListListHeaderUuidRoute
  AuthMemberMemberUuidRoute: typeof AuthMemberMemberUuidRouteWithChildren
  AuthMembershipMembershipUuidRoute: typeof AuthMembershipMembershipUuidRouteWithChildren
  AuthMembershiprequestUuidRoute: typeof AuthMembershiprequestUuidRoute
  AuthOrganizationOrganizationUuidRoute: typeof AuthOrganizationOrganizationUuidRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAwardsRoute: AuthAwardsRoute,
  AuthBeginRoute: AuthBeginRoute,
  AuthBirthdaysRoute: AuthBirthdaysRoute,
  AuthBulkUpdateSectionRoute: AuthBulkUpdateSectionRoute,
  AuthCalendarRoute: AuthCalendarRoute,
  AuthChartsRoute: AuthChartsRoute,
  AuthCreateMemberRoute: AuthCreateMemberRoute,
  AuthEducationRoute: AuthEducationRoute,
  AuthEducationImportRoute: AuthEducationImportRoute,
  AuthGildeReportsRoute: AuthGildeReportsRoute,
  AuthGrinsExportsRoute: AuthGrinsExportsRoute,
  AuthGrinsViewRoute: AuthGrinsViewRoute,
  AuthListMemberPivotRoute: AuthListMemberPivotRoute,
  AuthListsRoute: AuthListsRoute,
  AuthMedusaImportRoute: AuthMedusaImportRoute,
  AuthMembershipsRoute: AuthMembershipsRoute,
  AuthMembershipsOverviewRoute: AuthMembershipsOverviewRoute,
  AuthOrganizationHierarchyRoute: AuthOrganizationHierarchyRoute,
  AuthPermissionConfigRoute: AuthPermissionConfigRoute,
  AuthPostreceiverRoute: AuthPostreceiverRoute,
  AuthQualityAddressRoute: AuthQualityAddressRoute,
  AuthQualityMemberRoute: AuthQualityMemberRoute,
  AuthRegistrationRoute: AuthRegistrationRoute,
  AuthReportsRoute: AuthReportsRoute,
  AuthScoutcardRequestsRoute: AuthScoutcardRequestsRoute,
  AuthScoutcardsRoute: AuthScoutcardsRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthStartRoute: AuthStartRoute,
  AuthSwitchOrganizationRoute: AuthSwitchOrganizationRoute,
  AuthUploadMemberRoute: AuthUploadMemberRoute,
  AuthCreateMembershipRequestMembershipUuidRoute:
    AuthCreateMembershipRequestMembershipUuidRoute,
  AuthListListHeaderUuidRoute: AuthListListHeaderUuidRoute,
  AuthMemberMemberUuidRoute: AuthMemberMemberUuidRouteWithChildren,
  AuthMembershipMembershipUuidRoute:
    AuthMembershipMembershipUuidRouteWithChildren,
  AuthMembershiprequestUuidRoute: AuthMembershiprequestUuidRoute,
  AuthOrganizationOrganizationUuidRoute:
    AuthOrganizationOrganizationUuidRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  HelpRoute: HelpRoute,
  LogoutRoute: LogoutRoute,
  SelfServiceCreateUserRoute: SelfServiceCreateUserRoute,
  ApproveMembershipRequestMembershipRequestCodeRoute:
    ApproveMembershipRequestMembershipRequestCodeRoute,
  DownloadReportReportUuidRoute: DownloadReportReportUuidRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
